// extracted by mini-css-extract-plugin
module.exports = {"header":"MainHeader_header__lcmFN","active":"MainHeader_active__3Fmx_"};